import { render, staticRenderFns } from "./RealityButton.vue?vue&type=template&id=6ed624c3&scoped=true&"
import script from "./RealityButton.vue?vue&type=script&lang=js&"
export * from "./RealityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed624c3",
  null
  
)

export default component.exports